import { Fragment } from 'react'

import {
  Button,
  ButtonWhatsapp,
  Divider,
  HighlightTitle,
  If
} from '@/components'

import { FIELDS, MAX_NEGATIVATION_NUMBER } from './constants'

import { useCalculatorSummary } from './useCalculatorSummary'

import styles from './CalculatorSummary.module.scss'

export const CalculatorSummary = ({ showAdditionalServices, watch }) => {
  const { getFormattedValue } = useCalculatorSummary({ watch })

  return (
    <div className={styles.customPlan}>
      <p className={styles.customPlan__title}>Plano ideal</p>

      <div className={styles.customPlan__content}>
        {FIELDS.map(({ icon, name, label, max }, index) => (
          <Fragment key={`customPlan-text-${index}`}>
            <HighlightTitle
              size="medium"
              icon={icon}
              text={
                <span className={styles.customPlan__text}>
                  <b>{label}</b>
                </span>
              }
            />

            <p className={styles.customPlan__text}>
              {getFormattedValue(name, max)}
            </p>

            <Divider customClass={styles.customPlan__divider} />
          </Fragment>
        ))}

        <If condition={showAdditionalServices}>
          <>
            <HighlightTitle
              size="medium"
              icon="equifax-stamp"
              text={
                <span className={styles.customPlan__text}>
                  <b>Negativação e Notificação:</b>
                </span>
              }
            />

            <p className={styles.customPlan__text}>
              {getFormattedValue(
                'negativation_quantity',
                MAX_NEGATIVATION_NUMBER
              )}
            </p>
          </>
        </If>

        <Button
          type="submit"
          id="customPlan-seePlan-button"
          className={styles.customPlan__button}
        >
          Ver plano ideal
        </Button>

        <ButtonWhatsapp
          variant="secondary"
          id="customPlan-whatsapp-button"
          customClass={styles.customPlan__button}
        >
          Falar com especialista
        </ButtonWhatsapp>
      </div>
    </div>
  )
}
